import { useQuery } from 'react-query';
import situationsServices from './situations.services';

const YARD_MANAGEMENT_SITUATIONS_KEY = 'yard-management/situations/list';

export function useYardManagementSituationList(enabled = true) {
  return useQuery({
    queryKey: [YARD_MANAGEMENT_SITUATIONS_KEY],
    queryFn: situationsServices.list,
    enabled,
  });
}
